import { z } from 'zod/v4'
import createComponentSchema from '../util/createComponentSchema'

const GanttCategorySchema = z.object({
  id: z.string(),
  label: z.string(),
  backgroundColor: z.string().optional()
})

const GanttCaptionSchema = z.object({
  id: z.string(),
  label: z.string(),
  color: z.string().optional()
})

const GanttCardSchema = z.object({
  id: z.string(),
  categoryId: z.string(),
  rowIndex: z.number().int().min(0).max(15),
  start: z.string(),
  end: z.string(),
  label: z.string(),
  color: z.string().optional(),
  captionId: z.string().optional()
})

const GanttArrowSchema = z.object({
  id: z.string(),
  fromCardId: z.string(),
  toCardId: z.string(),
  originAnchor: z.enum(['bottom-start', 'bottom-center']).optional()
})

const GanttFooterSchema = z.object({
  leftLabel: z.string().optional(),
  milestones: z
    .array(
      z.object({
        label: z.string(),
        date: z.string(),
        description: z.string().optional()
      })
    )
    .optional()
})

const ganttChartPropsSchema = z.object({
  year: z.number().int().min(1970).max(2100).optional(),
  months: z.array(z.string()).length(12).optional(),
  categories: z.array(GanttCategorySchema).min(1),
  captions: z.array(GanttCaptionSchema).optional(),
  cards: z.array(GanttCardSchema),
  arrows: z.array(GanttArrowSchema).optional(),
  footer: GanttFooterSchema.optional(),
  highlightCurrentMonth: z.boolean().optional(),
  sidebarTitle: z.string().optional()
})

const GanttChartSchema = createComponentSchema(
  'GanttChart',
  ganttChartPropsSchema
)

export type GanttChartTemplateProps = z.infer<typeof ganttChartPropsSchema>

export default GanttChartSchema
